module.exports = __webpack_public_path__ + "img/Snipaste_2023-07-21_18-01-20.76e562b9.png";